import { render, staticRenderFns } from "./BookingDuplicateForm.vue?vue&type=template&id=3263c852"
import script from "./BookingDuplicateForm.vue?vue&type=script&lang=js"
export * from "./BookingDuplicateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports